export default __webpack_public_path__ + "static/media/FactoryIconNew.b30a071c.svg";